import { useQuery } from "react-query"
import { getBadges, getBadge } from "api/badges"

export const badgesCacheKey = (eventId: string) => ["badges", eventId]
export const badgeCacheKey = (eventId: string, badgeId: string) => ["badge", eventId, badgeId]

export const useBadges = (eventId: string) => useQuery(
  badgesCacheKey(eventId),
  () => getBadges(eventId).then(({ data }) => data),
  { enabled: Boolean(eventId) },
)

export const useBadge = (
  eventId: string,
  badgeId?: string,
) => useQuery(
  badgeId ? badgeCacheKey(eventId, badgeId) : [],
  () => getBadge(eventId, badgeId ?? "").then(({ data }) => data),
  { enabled: Boolean(badgeId) },
)
